import api from '../api'


export const getPowerBiToken = () =>
  api.get('/v1/auth/microsoft-token')
